module.exports = __webpack_public_path__ + "img/CombatArmor.700a57f7.gif";